
module.exports = function(angularModule) {

  angularModule.controller('WidgetTemplatesCtrl', function($scope) {
    $scope.widgetList = require('./defaultWidgets');
  });

};

